import { combineReducers } from 'redux';

import type { DynamicFormState } from './dynamicForm.model';
import { infosReducer } from './infos/infos.reducer';

export const dynamicFormReducer = combineReducers<DynamicFormState>({
  infos: infosReducer,
});
